export default __webpack_public_path__ + "static/media/bgrt.f20b2178.svg";